function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState, useEffect, useCallback, useRef } from 'react';
import Slider from 'react-slick';
import { OpenInFull } from '@styled-icons/material/OpenInFull';
import { ImageModal } from './image-modal';
import { GlobalSlickStyles, StyledNextArrow, StyledPrevArrow, BottomContainer, Image, OpenModal, ButtonText, Container, Screen, Dots, Dot, CaptionDesktop, CaptionMobileWrapper, CaptionMobile } from './Styles';
export const isAdvancedImage = image => image.src === undefined;
export const ImageCarousel = ({
  initialIndex = 0,
  images,
  height,
  width,
  className,
  ...rest
}) => {
  const [carouselHeight, setCarouselHeight] = useState(height || 0);
  const [modalOpen, setModalOpen] = useState(false);
  const carouselRef = useRef(null);
  const sliderRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  /* Setter 4:3 ratio for bilder om height-prop ikke er satt */
  const setImgHeight = useCallback(() => {
    if (carouselRef && carouselRef.current && !height) {
      const imageRatio = carouselRef.current.offsetWidth * 0.75;
      setCarouselHeight(imageRatio);
    }
  }, [height, carouselRef]);
  useEffect(() => {
    if (carouselRef?.current?.offsetWidth && carouselRef.current.offsetWidth > 0) setImgHeight();else {
      const desiredWidth = width ? parseInt(width) : 500;
      setCarouselHeight(desiredWidth * 0.75);
    }
  }, [width, carouselRef, setImgHeight]);
  useEffect(() => {
    window.addEventListener('resize', setImgHeight);
    return () => window.removeEventListener('resize', setImgHeight);
  }, [setImgHeight]);
  const description = images[currentIndex]?.description;
  // Slick handles this, but the way we provide images is not compatible with the default implementation. Therefore we need to handle this manually.
  const showArrows = images.length > 1;
  return /*#__PURE__*/React.createElement(Container, _extends({
    className: className,
    ref: carouselRef,
    $width: width ? `${width}px` : undefined
  }, rest), /*#__PURE__*/React.createElement(GlobalSlickStyles, null), /*#__PURE__*/React.createElement(Screen, null, /*#__PURE__*/React.createElement(Slider, {
    dots: images.length > 1,
    infinite: true,
    speed: 500,
    slidesPerRow: 1,
    prevArrow: showArrows ? /*#__PURE__*/React.createElement(StyledPrevArrow, null) : undefined,
    nextArrow: showArrows ? /*#__PURE__*/React.createElement(StyledNextArrow, null) : undefined,
    appendDots: dots => /*#__PURE__*/React.createElement(Dots, null, dots),
    customPaging: i => /*#__PURE__*/React.createElement(Dot, {
      "aria-label": `navigate to image ${i + 1}`
    }),
    beforeChange: (current, next) => setCurrentIndex(next),
    adaptiveHeight: true,
    lazyLoad: "anticipated",
    ref: sliderRef
  }, images.map(image => {
    const advancedImage = isAdvancedImage(image);
    return /*#__PURE__*/React.createElement(Image, {
      key: image.description,
      $isAdvancedImage: advancedImage,
      $height: carouselHeight
    }, !advancedImage ? /*#__PURE__*/React.createElement("img", {
      alt: image.altText,
      src: image.src,
      height: carouselHeight
    }) : image.image);
  })), /*#__PURE__*/React.createElement(BottomContainer, null, /*#__PURE__*/React.createElement(CaptionDesktop, null, description), /*#__PURE__*/React.createElement(OpenModal, {
    onClick: () => setModalOpen(true)
  }, /*#__PURE__*/React.createElement(OpenInFull, {
    height: 16,
    width: 16
  }), /*#__PURE__*/React.createElement(ButtonText, null, "\xC5pne i fullskjerm")))), /*#__PURE__*/React.createElement(CaptionMobileWrapper, {
    $hasDots: images.length > 1
  }, /*#__PURE__*/React.createElement(CaptionMobile, null, description)), /*#__PURE__*/React.createElement(ImageModal, {
    open: modalOpen,
    onClose: () => setModalOpen(false),
    images: images,
    initialIndex: currentIndex
  }));
};
//# sourceMappingURL=image-carousel.js.map